import type { ExternalTableSchema } from '@packages/table-builder';

export const jobTitlesTable: ExternalTableSchema = {
  metadata: {
    title: 'Job Titles',
    entity: 'job-title',
    subtitle: 'Current list of Wealthlane system access job titles.',
  },
  dataSource: {
    endpoint: '/api/customer/api/app/customer-title/customer-title-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: { items: 'items', totalCount: 'totalCount' },
  },
  columns: [
    { field: 'name', header: 'Job Titles', type: 'text', width: 300, sortable: true },
    { field: 'description', header: 'Description', type: 'text', width: 300 },
  ],
  actions: {
    toolbar: {
      primary: { id: 'ADD_JOB_TITLE', label: 'Add Job Title', icon: 'add_circle_outline' },
      secondary: [
        {
          type: 'download',
          children: [{ id: 'DOWNLOAD_TEMPLATE_JOB_TITLES', label: 'Download Template' }],
        },
        {
          type: 'upload',
          children: [{ id: 'IMPORT_JOB_TITLES', label: 'Import Bulk XLS' }],
        },
      ],
    },
    row: [
      { id: 'VIEW_JOB_TITLE', label: 'View' },
      { id: 'EDIT_JOB_TITLE', label: 'Edit' },
      { id: 'DELETE_JOB_TITLE', label: 'Delete', variant: 'danger' },
    ],
  },
  features: {
    search: { enabled: true, placeholder: 'Search' },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    import: { enabled: true },
    columnPreferences: { persistenceKey: 'Job Titles', resizable: true, reorderable: true },
  },
};
